require('../../default/js/app');
require('./core');

/**
 * Import all required styles.
 */
import '../../default/scss/app.scss';
